import React from "react";

import { ISelectOption } from "../common/interfaces";
import { useTranslation } from "react-i18next";

interface IProps {
  name: string;
  value?: string;
  label: string;
  className?: string;
  multiple?: boolean;
  options: ISelectOption[];
  defaultPlaceholder?: string;
  disabled?: boolean;
  onChange: (value: string | number) => void;
}

export const FormSelect = (props: IProps) => {
  let { options, value, label, name, defaultPlaceholder, multiple, className, disabled, onChange } = props;

  const { t } = useTranslation();

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    value = event.target.value;
    onChange(value);
  };

  const multipleDefaultValues = options.filter((option) => option.selected).map((option) => option.value.toString());

  return (
    <div className={`form-group ${className ?? ""}`}>
      <label htmlFor={name} className="text-uppercase text-secondary">
        {label}
      </label>
      <select
        name={name}
        value={value}
        multiple={multiple}
        disabled={disabled}
        size={multiple ? options.length : undefined}
        onChange={handleSelectChange}
        defaultValue={multiple ? multipleDefaultValues : ""}
        className="form-control shadow-none py-2 px-3"
      >
        {!multiple && (
          <option value="" disabled>
            {t("dashboard.inputSelect")} {defaultPlaceholder?.toLowerCase()}
          </option>
        )}
        {options.map((option, i) => (
          <option value={option.value} key={option.value + i.toString()} defaultChecked={option.selected}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
